module.exports = __webpack_public_path__ + "static/media/md-heart.cf814990.svg";